/**
 * 页面权限
 */
export const SECRET_AUCTION_LIST_PAGE_UUID =
  'b2be672b-0df9-484b-a599-687e36185563'
